<template>
  <div>
    <Top/>
    <div class="cght_htmainbox cght_htmainboxnobg">
      <div class="cght_htmain cgw1216" v-loading="qyloading">
        <!--内容区域 开始-->
        <div class="cght_height30"></div>
        <template v-if="goodsList.length > 0">
        <div class="cght_gwcti">
          <div class="cght_gwctibo"><em>全部商品</em>
            <!--<div>10</div>-->
          </div>
        </div>
        <div class="cght_gwcdtop">
          <div class="cght_gwcdtop1" style="text-align:left;">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          </div>
          <div class="cght_gwcdtop2">商品</div>
          <div class="cght_gwcdtop3">单价（元）</div>
          <div class="cght_gwcdtop4">数量</div>
          <div class="cght_gwcdtop5">小计（元）</div>
          <div class="cght_gwcdtop6">操作</div>
        </div>
        <!-- <div class="cght_height26"></div> -->
        <ul class="cght_gwcdullis">
          <li cartall="cartall1" v-for="(item,index) in goodsList" :key="index">
            <div class="cght_gwcdtop1">
              <em class="cght_gwcdtop1inpu">
                <el-checkbox v-model="item.checkType" @change="handleCheckedCitiesChange(item,index)"></el-checkbox> <!-- :disabled="item.tax_price?false:true" -->
              </em>
              <div class="cght_gwcdtop1img">
                <router-link :to="{path:'/GoodsDetail', query:{id:item.goods_id}}" target="_blank" :title="item.title">
                  <img v-real-img="item.imgpath" src="../../assets/images/zwtp.jpg" width="80" height="80" />
                </router-link>
              </div>
            </div>
            <div class="cght_gwcdtop2">
              <div class="cght_gwcdtop2l">
                <h3>
                  <router-link class="car_title" :to="{path:'/GoodsDetail', query:{id:item.goods_id}}" target="_blank" :title="item.title">
                    {{item.title}}
                  </router-link>
                </h3>
              </div>
              <div class="cght_gwcdtop2l">
                <div v-for="(spe,i) in item.specParamList" :key="i" style="float:left;margin-left:10px">
                  {{spe.param_name}}:{{spe.option_value}}
                </div>
              </div>
              <div class="cght_gwcdtop2l" style="width:100%;padding:0;">
                <leave-message v-if="item.leaveType" :ref="'leavemsg'+index" :msgjson="item.leaveMessage" v-model="item.leaveMessage"></leave-message>
                <!-- <div v-if="item.leaveType">123123</div> -->
                <div v-else v-for="(spe,i) in item.leaveMessage" :key="i" class="myleave">
                  {{spe.name}}：{{spe.value}}
                </div>
              </div>
            </div>
            <div class="cght_gwcdtop3">
              <div class="cght_gwcdtop3a">
                <span v-if="item.tax_price && item.tax_price > 0">￥{{item.tax_price}}</span><!-- &emsp;<em>￥23.14</em> -->
                <span v-else class="xunjia">询价</span>
              </div>
            </div>
            <div class="cght_gwcdtop4">
              <div class="cght_gwcdtop4b yubing">{{item.plant_sku || item.sku}}</div>
              <div class="cght_gwcdtop4a">
                <el-input-number v-model="item.number" :min="item.limits || 1" size="mini" label="数量" @change="numChange(index)"></el-input-number>
              </div>
              <div class="cght_gwcdtop4b" v-if="item.delivery_time">{{item.delivery_time}}个工作日内出货</div>
              <div class="cght_gwcdtop4b" v-else>今日出货</div>
            </div>
            <div class="cght_gwcdtop5" v-if="item.tax_price && item.tax_price > 0">￥{{(item.number * item.tax_price).toFixed(2)}}</div>
            <div class="cght_gwcdtop5" v-else>询价</div>
            <div class="cght_gwcdtop6">
              <div class="cght_gwcdtop6a_a" style="padding-top: 50px;">
                <a href="javascript:void(0);" @click="aloneDel(item.id)">删除</a>
                <!-- <a href="javascript:void(0);">收藏</a> -->
              </div>
            </div>
          </li>
        </ul>
        <!-- <div class="cght_height16"></div> -->
        <div class="cght_gwcjiesun">
          <div class="cght_gwcjiesunl">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>&emsp;
            <a href="javascript:void(0);" @click="delCart">删除选中的商品</a>&emsp;
            <a href="javascript:void(0);" @click="moveCollect">添加到我的收藏</a>
          </div>
          <div class="cght_gwcjiesunr">
            <a href="javascript:void(0);" class="cght_gwcjiesunran" cartsubmit="cartsubmit" @click="addOrder">下&emsp;单</a>
            <div class="cght_gwcjiesunratwo">
              <div class="cght_gwcjiesunratwoa">已选择
                <em class="cght_gwcjiesunratwoaema" cartallnum="cartallnum">{{checkedArr.length}}</em>
                  种商品&emsp;总价（不含运费）：
                <em class="cght_gwcjiesunratwoaemb" cartallprice="cartallprice">￥{{totalPrice}}</em>
              </div>
            </div>
          </div>
        </div>
        </template>
        <div class="cght_meiyoudingdan" style="display: block" v-if="isLoading&&goodsList.length==0">
          <div class="cght_meiyoudingdand">
            <em>还没有商品哦~</em>
            <router-link :to="{path:'/'}">去首页看看</router-link>
          </div>
        </div>
      </div>
      <div class="cght_height105"></div>
      <div class="cght_xhscls" style="margin:0 auto" v-show="false">
        <div class="cght_cnxh">
          <div class="cght_cnxhti"><h2>猜你喜欢</h2><a datachangelike>换一批</a></div>
          <div class="cght_cnxhtiwtjsp" style="display:none;"><div>暂无推荐商品</div></div>
          <ul class="cght_cnxhul">
            <li>
              <a href="" target="_blank" title="" class="cght_cnxhula">
                <img v-real-img="" width="160" height="160" alt="" />
              </a>
              <h3><a href="" target="_blank" title="">FGH</a></h3>
              <div>￥0.01</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Bottom/>
  </div>
</template>
<script>
import Top from '@/components/Member/Top'
import Bottom from '@/components/Member/Bottom'
import api from '@/api/goods'
import LeaveMessage from '@/components/LeaveMessage'

export default {
  components: { Top, Bottom, LeaveMessage },
  name: 'Cart',
  data () {
    return {
      goodsList: [],
      isLoading: false,
      qyloading: false,
      checkedArr: [],
      checkAll: false,
      isIndeterminate: true,
      id_list: [],
      leaveList: []
    }
  },
  computed: {
    totalPrice () {
      let totalPrice = 0
      this.goodsList.map(res => {
        res.checkType ? totalPrice += res.number * res.tax_price : totalPrice += 0
      })
      return totalPrice.toFixed(2)
    }
  },
  mounted () {
    this.getCartList()
  },
  methods: {
    getCartList () {
      this.qyloading = true
      api.getCartList().then(res => {
        let statementGoods = res.items
        this.qyloading = false
        this.isLoading = true
        statementGoods.map(response => {
          if (response.specParamList) {
            response.specParamList = JSON.parse(response.specParamList)
          }
          response.leaveType = false
          if (response.leaveMessage) {
            response.leaveMessage = JSON.parse(response.leaveMessage)
            if (response.leaveMessage.length > 0 && response.leaveMessage[0].msgTitle) {
              response.leaveType = true
              response.leaveMessage = JSON.stringify(response.leaveMessage)
            }
          }
          response.checkType = false
        })
        this.goodsList = statementGoods
        this.id_list = res.id_list
      })
    },
    numChange (index) {
      api.updateCart({'id': this.goodsList[index]['id'], 'number': this.goodsList[index]['number']}).then(res => {

      })
    },
    handleCheckAllChange () {
      this.isIndeterminate = false
      if (this.checkAll) {
        this.leaveList = []
        this.goodsList.forEach(res => {
          res.checkType = true
          if (res.leaveType) {
            this.leaveList.push({id: res.id, leaveMessage: res.leaveMessage})
          }
        })
        this.checkedArr = this.id_list
      } else {
        this.goodsList.forEach(res => { res.checkType = false })
        this.checkedArr = []
        this.leaveList = []
      }
    },
    handleCheckedCitiesChange (item, index) {
      if (item.checkType) {
        this.checkedArr.splice(index, 0, item.id)
        if (item.leaveType) {
          this.leaveList.push({id: item.id, leaveMessage: item.leaveMessage})
        }
      } else {
        this.checkedArr.splice(this.checkedArr.indexOf(item.id), 1)
        if (item.leaveType) {
          var wzk = this.leaveList.findIndex(ret => {
            if (ret.id === item.id) {
              return true
            }
          })
          this.leaveList.splice(wzk, 1)
        }
      }
      if (this.goodsList.length === this.checkedArr.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    delCart () {
      if (this.checkedArr.length < 1) {
        this.$message.error('请先选择要删除的产品')
        return
      }
      this.$confirm('是否删除所选的产品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delCart({id_list: this.checkedArr}).then(res => {
          this.getCartList()
        })
      }).catch(() => {})
    },
    aloneDel (id) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.delCart({id_list: id}).then(res => {
          this.getCartList()
        })
      }).catch(() => {})
    },
    moveCollect () {
      if (this.checkedArr.length < 1) {
        this.$message.error('请先选择要收藏的产品')
        return
      }
      this.$confirm('是否收藏所选的产品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.moveCollect({id_list: this.checkedArr}).then(res => {
          this.$message({
            message: '收藏成功',
            type: 'success'
          })
        })
      }).catch(() => {})
    },
    addOrder () {
      if (this.checkedArr.length < 1) {
        this.$message.error('请先选择要下单的产品')
        return
      }
      // foreach 是一个函数   for 是个指令 return 只能退出匿名函数，所以这里用for循环
      for (var i = 0; i < this.goodsList.length; i++) {
        if (this.goodsList[i].checkType && this.goodsList[i].leaveType && !this.$refs['leavemsg' + i][0].valid()) {
          return false
        }
      }
      if (this.leaveList.length > 0) {
        // 如果有产品信息需要补充先执行购物车修改在跳转页面
        api.updateCartLeave(this.leaveList).then(res => {
          localStorage.setItem('cart_checkList', JSON.stringify(this.checkedArr))
          // 因为与申购单共用ConfirmOrder页面，所以与跳转前清除申购单的store值
          localStorage.removeItem('preorderList')
          localStorage.removeItem('nowBuy_goods')
          localStorage.removeItem('fastList')
          this.$router.push({path: '/ConfirmOrder'})
        })
        return false
      } else {
        localStorage.setItem('cart_checkList', JSON.stringify(this.checkedArr))
        // 因为与申购单共用ConfirmOrder页面，所以与跳转前清除申购单的store值
        localStorage.removeItem('preorderList')
        localStorage.removeItem('nowBuy_goods')
        localStorage.removeItem('fastList')
        this.$router.push({path: '/ConfirmOrder'})
      }
    }
  }
}
</script>
<style scoped>
  .cght_gwcdtop{
    text-align:center;
  }
  .cght_gwcdtop4a{
    width:130px;
  }
  .car_title{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
  .xunjia{
    color:#fe722c;
  }
  ::v-deep .detailUse{
    font-size: 12px!important;
    line-height: 28px!important;
    height: 28px;
    color: #86abd0!important;
    padding-left: 10px;
  }
  ::v-deep .mySpecParam > div > div > input{
    height: 28px;
    line-height: 28px;
  }
  ::v-deep .mySpecParam > div{
    float: left;
  }
  .cght_gwcdtop3{
    width: 150px;
  }
  .cght_gwcdtop2{
    width: 535px;
  }
  .cght_gwcdtop5{
    width: 150px;
  }
  .cght_gwcdtop6{
    width: 105px;
  }
  .cght_gwcdtop2l{
    line-height: 18px;
    width: 50%;
  }
  .cght_gwcdullis .cght_gwcdtop2{
    height: auto;
  }
  .myleave{
    float:left;
    margin-left:10px;
    color:#86abd0;
  }
  .yubing{
    padding-top:20px;
  }
</style>
<style>
  .el-checkbox__inner {
    border-color: #666666!important;
  }
</style>



// WEBPACK FOOTER //
// src/view/cart/cart.vue